module.exports = __webpack_public_path__ + "img/logo-min.a2481620.png";